import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FutureHistoryTradeService } from '@pg-app/client/client-dashboard/components/future-history-trade/services/future-history-trade.service';
import { format, getDaysInMonth } from 'date-fns';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ShareService } from '@nttp/common-service/share-service';
import { DetailedTradeHistoryService } from '@pg-app/client/detailed-trade-history/detailed-trade-history.service';
import { StatementReportService } from '@pg-app/client/statement-report/statement-report-service';
import { UtilityService } from '@nttp/common-service/utility-service';
import * as lodash from 'lodash';
import { TableTradeService } from '@pg-app/client/client-dashboard/components/tables/table.service';
import { ToastrService } from 'ngx-toastr';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { Router } from '@angular/router';
import { TradeTypeEnum } from '@nttp/common-service/trade-type-enum';
import { PaymentHistoryService } from '@pg-app/client/payment/services/payment-history.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { UserRoleEnum } from '@nttp/enum/user-role.enum';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';
import { CommonMessages } from '@pg-app/shared/constants/common-messages';
import { ClientProfileService } from '../services/client-profile.service';

@Component({
  selector: 'np-detailed-trade-history',
  templateUrl: './detailed-trade-history.component.html',
  styleUrls: ['./detailed-trade-history.component.scss']
})
export class DetailedTradeHistoryComponent implements OnInit {
  chartData = [];
  xAxisLabel = 'Months';
  yAxisLabel = 'No. of trades';
  colorScheme = {
    domain: ['#a5b3bf', '#011e41']
  };
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  searchForm: FormGroup;
  currencies = [];
  tradeStatus = [
    {
      id: 3,
      name: 'Settled'
    },
    {
      id: 1,
      name: 'Outstanding'
    }
  ];

  addDrawdown = [
    this.tradeTypeEnum.SPOT_2_DV,
    this.tradeTypeEnum.EXTENDED_SPOT_5_DV,
    this.tradeTypeEnum.NEXT_DAY,
    this.tradeTypeEnum.OPEN_DATE_FORWARD_ODF,
    this.tradeTypeEnum.SWAPS_ROLLOVER,
    this.tradeTypeEnum.SWAPS_DRAWDOWN
  ];

  public rows = [];
  public columns = [];
  isLoading = true;

  showFilter = false;
  tradeTypes = [];
  barPadding = 15;
  showYAxisLabel = true;
  allFilter = [
    'Trade confirmation',
    'Drawdown',
    'Trade reference',
    'Associated trade reference',
    'Creation date',
    'Trade type',
    'Value date',
    'Sell currency',
    'Sell: Original notional',
    'Sell: Remaining notional',
    'Rate',
    'Buy currency',
    'Buy: Original notional',
    'Buy: Remaining notional',
    'Value date'
  ];
  todo = [];
  done = [];
  allColumns = [
    {
      title: 'Trade confirmation',
      name: 'confirmation',
      hiddenSort: true,
      hiddenFilter: true,
      width: '120px',
    },
    {
      title: 'Drawdown',
      name: 'drawdown',
      hiddenSort: true,
      hiddenFilter: true,
      width: '150px'
    },
    {
      title: 'Trade reference',
      name: 'tradeReference',
      width: '150px'
    },
    {
      title: 'Associated trade reference',
      name: 'associatedTradeReference',
      class: 'asociated-trade',
      width: '150px'
    },
    {
      title: 'Creation date',
      name: 'creationDate',
      type: TableCellTypes.Date,
      width: '150px'
    },
    {
      title: 'Trade type',
      name: 'tradeType',
      width: '150px'
    },
    {
      title: 'Open date',
      name: 'openDate',
      type: TableCellTypes.Date,
      width: '150px'
    },
    {
      title: 'Sell currency',
      name: 'sellCurrency',
      width: '150px'
    },
    {
      title: 'Sell: Original notional',
      name: 'sellOriginalNotional',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Sell: Remaining notional',
      name: 'sellRemainingNotional',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Rate',
      name: 'rate',
      type: TableCellTypes.Rate,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Buy currency',
      name: 'buyCurrency',
      width: '150px'
    },
    {
      title: 'Buy: Original notional',
      name: 'buyOriginalNotional',
      type: TableCellTypes.Rate,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Buy: Remaining notional',
      name: 'buyRemainingNotional',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Value date',
      name: 'valueDate',
      type: TableCellTypes.Date,
      width: '150px'
    }
  ];
  showDownloadConsolidated = false;

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  constructor(
    private futureHistoryTradeService: FutureHistoryTradeService,
    private fb: FormBuilder,
    private detailedTradeService: DetailedTradeHistoryService,
    private statementReportService: StatementReportService,
    private sharingService: ShareService,
    private utilityService: UtilityService,
    private tableTradeService: TableTradeService,
    private toastr: ToastrService,
    private registrationService: RegistrationStep2Service,
    private router: Router,
    private tradeTypeEnum: TradeTypeEnum,
    private paymentHistoryService: PaymentHistoryService,
    private breakpointObserver: BreakpointObserver,
    private clientService: ClientProfileService,
  ) {}

  ngOnInit() {

    const today = new Date();
    const toDateDefault = new Date(today.getFullYear(), today.getMonth(), getDaysInMonth(today));
    const fromDateDefault = new Date(today.getFullYear(), today.getMonth(), 1);
    
    this.searchForm = this.fb.group({
      fromDate: fromDateDefault,
      toDate: toDateDefault,
      buyCurrency: 0,
      buyAmount: '',
      tradeStatus: 0,
      openDate: '',
      sellCurrency: 0,
      sellAmount: '',
      tradeReference: '',
      tradeType: 0,
      rate: '',
    });
    this.getHistoryChartData();
    this.getCurrencies();

    this.getColumns();
    this.getTradeType();
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe(result => {
      this.barPadding = result.matches ? 5 : 15;
      this.showYAxisLabel = result.matches ? false : true;
    });
    this.clientService.singleEmailAccounts$.subscribe(res => {
      this.showDownloadConsolidated = res;
    })
  }

  getTradeType() {
    this.detailedTradeService.getTradeTypes().subscribe(res => {
      this.tradeTypes = res;
    });
  }

  getColumns() {
    this.todo = [];
    this.done = [];
    const params = {
      leadId: null,
      report: 3,
      columns: null
    };
    this.statementReportService.getColumns(params).subscribe(data => {
      if (data && data.length > 0) {
        const columns = data.sort((previous, next) => {
          return previous.order > next.order ? 1 : -1;
        });

        this.columns = [];
        columns.forEach(item => {
          const column = this.allColumns.find(p => p.name === item.columnName);
          this.todo.push(column.title);

          const columnTable = this.allColumns.find(p => p.name === item.columnName);
          this.columns.push(columnTable);
        });
        this.done = this.allColumns.filter(column => this.todo.indexOf(column.title) < 0).map(d => d.title);
      } else {
        this.todo = this.allColumns.map(d => d.title);
        this.done = [];
        this.columns = this.allColumns;
      }

      this.getTableData();
    });
  }

  getTableData() {
    let tableData = [];
    const params = {
      leadId: null,
      tradeRef: this.searchForm.get('tradeReference').value || null,
      fromDate: this.searchForm.get('fromDate').value
        ? format(this.searchForm.get('fromDate').value, 'YYYYMMDD')
        : null,
      toDate: this.searchForm.get('toDate').value ? format(this.searchForm.get('toDate').value, 'YYYYMMDD') : null,
      tradeTypeId: this.searchForm.get('tradeType').value || null,
      sellCurrencyId: this.searchForm.get('sellCurrency').value || null,
      sellAmount: this.searchForm.get('sellAmount').value ? parseFloat(this.searchForm.get('sellAmount').value) : null,
      buyCurrencyId: this.searchForm.get('buyCurrency').value || null,
      buyAmount: this.searchForm.get('buyAmount').value ? parseFloat(this.searchForm.get('buyAmount').value) : null,
      rate: this.searchForm.get('rate').value ? parseFloat(this.searchForm.get('rate').value) : null,
      tradeStatus: this.searchForm.get('tradeStatus').value ? parseFloat(this.searchForm.get('tradeStatus').value) : null,
      openDate: this.searchForm.get('openDate').value ? format(this.searchForm.get('openDate').value, 'YYYYMMDD') : null
    };

    this.detailedTradeService.getTradeHistoryDetail(params).subscribe(res => {
      if (res.length > 0) {
        res.forEach(trade => {
          tableData = tableData.concat(trade);
          if (trade.associatedTradeReference && trade.associatedTradeReference.length > 0) {
            const drawdowns = lodash.cloneDeep(trade.associatedTradeReference);
            trade.associatedTradeReference = 'View';
            drawdowns.forEach(drawdown => {
              drawdown.class = `drawdown ${trade.tradeReference} d-none`;
            });
            tableData = tableData.concat(drawdowns);
          }
        });
      }
      tableData.forEach(item => {
        item.confirmation = `<span class="btn-action">Download</span>`;
        if (
          new Date(item.valueDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) &&
          this.addDrawdown.indexOf(item.tradeType) !== -1 &&
          item.sellRemainingNotional > 0 &&
          item.buyRemainingNotional > 0 &&
          item.state !== 0
        ) {
          item.drawdown = `<span class="btn-action">Drawdown</span>`;
        }
      });
      this.rows = tableData;
      this.isLoading = false;
    });
  }

  public getSearchData() {
    if (
      this.searchForm.get('fromDate').value &&
      this.searchForm.get('toDate').value &&
      new Date(this.searchForm.get('fromDate').value) > new Date(this.searchForm.get('toDate').value)
    ) {
      this.toastr.error('From date can not be greater than To Date');
      return;
    }

    this.getTableData();

    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }, 500);
  }

  downloadExcel(consolidated) {
    const params = {
      leadId: null,
      tradeRef: this.searchForm.get('tradeReference').value || null,
      fromDate: this.searchForm.get('fromDate').value
        ? format(this.searchForm.get('fromDate').value, 'YYYYMMDD')
        : null,
      toDate: this.searchForm.get('toDate').value ? format(this.searchForm.get('toDate').value, 'YYYYMMDD') : null,
      tradeTypeId: this.searchForm.get('tradeType').value || null,
      sellCurrencyId: this.searchForm.get('sellCurrency').value || null,
      sellAmount: this.searchForm.get('sellAmount').value ? parseFloat(this.searchForm.get('sellAmount').value) : null,
      buyCurrencyId: this.searchForm.get('buyCurrency').value || null,
      buyAmount: this.searchForm.get('buyAmount').value ? parseFloat(this.searchForm.get('buyAmount').value) : null,
      rate: this.searchForm.get('rate').value ? parseFloat(this.searchForm.get('rate').value) : null,
      tradeStatus: this.searchForm.get('tradeStatus').value || null,
      openDate: this.searchForm.get('openDate').value ? format(this.searchForm.get('openDate').value, 'YYYYMMDD') : null,
      consolidatedMode: consolidated
    };

    this.detailedTradeService.exportExcel(params).subscribe(data => {
      const fileName = `Detailed_Trade_History.xlsx`;
      this.utilityService.downloadFile(
        data,
        fileName,
        DownloadFileTypeEnum.Excel
      );
    });
  }

  public getCurrencies() {
    this.sharingService.currencyList$.subscribe(
      data => {
        this.currencies = data || [];
      },
    );
  }

  public getHistoryChartData() {
    this.chartData = [];
    const today = new Date();
    const dateHistoryDefault = new Date(today.getFullYear() - 1, today.getMonth() + 1, 1);

    const chartData = {
      fromDate: format(dateHistoryDefault, 'YYYYMMDD'),
      toDate: format(new Date(), 'YYYYMMDD')
    };

    this.futureHistoryTradeService.getHistoryChartData(chartData).subscribe(
      data => {
        data = data || [];
        const array = new Array('GBP', 'EUR', 'USD');
        data = this.sort(data);

        data.forEach(item => {
          if (item.historyForCurrencies) {
            const outstandingsGBP = item.historyForCurrencies.find(
              p => p.state === 1 && array.indexOf(p.currency) === 0
            );
            const outstandingsEUR = item.historyForCurrencies.find(
              p => p.state === 1 && array.indexOf(p.currency) === 1
            );
            const outstandingsUSD = item.historyForCurrencies.find(
              p => p.state === 1 && array.indexOf(p.currency) === 2
            );
            const outstandingsOther = item.historyForCurrencies.filter(
              p => p.state === 1 && array.indexOf(p.currency) < 0
            );

            const settledsGBP = item.historyForCurrencies.find(p => p.state === 3 && array.indexOf(p.currency) === 0);
            const settledsEUR = item.historyForCurrencies.find(p => p.state === 3 && array.indexOf(p.currency) === 1);
            const settledsUSD = item.historyForCurrencies.find(p => p.state === 3 && array.indexOf(p.currency) === 2);
            const settledsOther = item.historyForCurrencies.filter(p => p.state === 3 && array.indexOf(p.currency) < 0);

            const dataCustom = {
              name: `${this.monthNames[item.month - 1]}`,
              series: [
                {
                  name: 'Settled',
                  value: item.totalNumbersSettled,
                  extra: {
                    gbp: settledsGBP ? settledsGBP.amount : 0,
                    eur: settledsEUR ? settledsEUR.amount : 0,
                    usd: settledsUSD ? settledsUSD.amount : 0,
                    other: settledsOther.length > 0 ? settledsOther.map(p => p.amount).reduce((a, b) => a + b, 0) : 0,
                    class: 'heather',
                    month: item.month,
                    year: item.year
                  }
                },
                {
                  name: 'Outstanding',
                  value: item.totalNumbersOutstanding,
                  extra: {
                    gbp: outstandingsGBP ? outstandingsGBP.amount : 0,
                    eur: outstandingsEUR ? outstandingsEUR.amount : 0,
                    usd: outstandingsUSD ? outstandingsUSD.amount : 0,
                    other:
                      outstandingsOther.length > 0
                        ? outstandingsOther.map(p => p.amount).reduce((a, b) => a + b, 0)
                        : 0,
                    class: 'dark-blue',
                    month: item.month,
                    year: item.year
                  }
                }
              ]
            };
            this.chartData = this.chartData.concat(dataCustom);
          } else {
            const dataCustom = {
              name: `${this.monthNames[item.month - 1]}`,
              month: item.month,
              year: item.year,
              series: [
                {
                  name: 'Settled',
                  value: 0,
                  extra: {
                    month: item.month,
                    year: item.year
                  }
                },
                {
                  name: 'Outstanding',
                  value: 0,
                  extra: {
                    month: item.month,
                    year: item.year
                  }
                }
              ]
            };
            this.chartData = this.chartData.concat(dataCustom);
          }
        });
      },
    );
  }

  private sort(data: any[]) {
    return data.sort((previous: any, current: any) => {
      let previousVal = previous['year'];
      let currentVal = current['year'];
      if (previousVal > currentVal) {
        return 1;
      } else if (previousVal < currentVal) {
        return -1;
      } else {
        previousVal = previous['month'];
        currentVal = current['month'];

        if (previousVal > currentVal) {
          return 1;
        } else if (previousVal < currentVal) {
          return -1;
        }
      }
      return 0;
    });
  }

  onCellClick(trade) {
    if (trade.column === 'confirmation') {
      const params = {
        leadId: null,
        tradeNumber: parseFloat(trade.row.tradeReference)
      };
      this.tableTradeService.downloadPDF(params).subscribe(
        res => {
          const fileName = `Trade_${trade.row.tradeReference}.pdf`;
          this.utilityService.downloadFile(res, fileName, DownloadFileTypeEnum.PDF);
        }
      );
    } else if (trade.column === 'drawdown' && trade.row.drawdown) {
      if (this.registrationService.userRole === UserRoleEnum.ReadOnly) {
        return;
      }

      this.utilityService.isAccountOperational().subscribe(isOk => {
        if (isOk) {
          this.router.navigate(['/client/add-drawdown'], { queryParams: { id: trade.row.tradeId } });
        } else {
          this.toastr.error(CommonMessages.accountNotOperational);
        }
      });

    } else if (trade.column === 'associatedTradeReference' && trade.row.associatedTradeReference) {
      const classColors = `${trade.row.tradeReference}`;
      const drawdowns = Array.from(document.getElementsByClassName(classColors));
      if (drawdowns.length > 0) {
        const hiddenDrawdown = drawdowns.find(item => item.classList.contains('d-none'));
        drawdowns.forEach(drawdown => {
          if (hiddenDrawdown) {
            drawdown.classList.remove('d-none');
            drawdown.classList.add('d-flex');
          } else {
            drawdown.classList.remove('d-flex');
            drawdown.classList.add('d-none');
          }
        });
      }
    }
  }

  reOrder() {
    this.isLoading = true;
    let reportColumns = [];
    let newColumns = [];
    this.todo.forEach(item => {
      newColumns = newColumns.concat(this.allColumns.find(p => p.title === item));
    });
    this.columns = newColumns;
    this.columns.forEach(item => {
      reportColumns = reportColumns.concat({
        columnName: item.name,
        order: this.columns.indexOf(item)
      });
    });
    const params = {
      leadId: null,
      report: 3,
      columns: reportColumns
    };

    this.paymentHistoryService.updateReportColumns(params).subscribe(() => this.isLoading = false);
  }

  togglePicker(picker) {
    picker.opened ? picker.close() : picker.open();
  }

  getAllTradesByMonth($event) {
    const month = $event.extra.month;
    const year = $event.extra.year;
    const fromDate = new Date(year, month - 1, 1);
    const toDate = new Date(year, month - 1, getDaysInMonth(fromDate));
    const tradeStatus = this.tradeStatus.find(item => item.name === $event.name);
    this.resetSearchForm(fromDate, toDate, tradeStatus.id);
    this.getSearchData();
  }

  resetSearchForm(fromDate = null, toDate = null, tradeStatus = null) {
    this.searchForm.patchValue({
      fromDate: fromDate,
      toDate: toDate,
      buyCurrency: 0,
      buyAmount: null,
      tradeStatus: tradeStatus || 0,
      openDate: null,
      sellCurrency: 0,
      sellAmount: null,
      tradeReference: null,
      tradeType: 0,
      rate: null,
    });
  }
}
